import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../../api';
import moment from 'moment-mini';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Quality Control',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Quality Control',
        href: '/opc/eor/quality-control',
        active: true,
      },
    ],
    title_form: 'EOR - Form Quality Control',

    items: [],
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_qc',
    sortDesc: true,
    fields: [
      {
        key: 'code_qc',
        label: 'Quality No',
        sortable: true,
      },
      {
        key: 'tgl_qc',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'begin_repair',
        label: 'Begin',
        sortable: true,
      },
      {
        key: 'complete_repair',
        label: 'Complete',
        sortable: true,
      },
      {
        key: 'complete_repair',
        label: 'Complete',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      id_wo_detail: '',
      id_container: '',
      container: '',
      size: '',
      type: '',
      code_wo: '',
      tgl_wo: '',
      begin_repair: '',
      complete_repair: '',
      remark_qc: '',
      damages: [],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeQC(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetFormQC() {
    state.data = Object.assign({}, state.data, {
      form: {
        id_wo_detail: '',
        id_container: '',
        container: '',
        size: '',
        type: '',
        code_wo: '',
        tgl_wo: '',
        begin_repair: '',
        complete_repair: '',
        remark_qc: '',
        damages: [],
      },
      search: '',
    });
  },
};

export const actions = {
  async getListQualityControl({ commit, state }) {
    commit('changeQC', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: data.id_principle ? data.id_principle : '',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`opr/quality-control`, params);
    commit('changeQC', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDownloadFilesMulti({ commit }, payload = null) {
    commit('changeQC', {
      loading: true,
    });

    let result = await ApiPostRequest('opr/download/multi', {
      ...payload,
    });

    commit('changeQC', {
      loading: false,
    });
    if (result) {
      return result.data.object;
    }
  },

  async getDetailContainerWO({ commit }, payload = null) {
    commit('changeQC', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/quality-control/container-wo/${payload.id}`
    );
    commit('changeQC', {
      loading: false,
    });

    if (!result.error) {
      commit('changeQC', {
        form: {
          ...result.data.object,
        },
      });
    }

    return !result.error ? true : false;
  },

  async uploadImage({ commit }, payload) {
    commit('changeQC', {
      loading: true,
    });

    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeQC', {
      loading: false,
    });

    if (!result.error) {
      return result.data.object || false;
    }
  },

  async searchContWO({ commit, state }) {
    commit('changeQC', {
      loading: true,
    });

    const { data } = state;
    let params = {
      container: data.form.container || '',
    };

    let result = await ApiGetRequest(`opr/quality-control/search`, params);
    commit('changeQC', {
      loading: false,
    });

    if (!result.error) {
      commit('changeQC', {
        form: {
          ...result.data.object,
        },
      });
    }

    return !result.error ? true : false;
  },

  async getDetailQC({ commit }, payload = null) {
    commit('changeQC', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/quality-control/${payload.id}`);
    commit('changeQC', {
      loading: false,
    });

    if (!result.error) {
      commit('changeQC', {
        form: {
          ...result.data.object,
        },
      });
    }

    return !result.error ? true : false;
  },

  async createQC({ commit, state, dispatch }, payload = null) {
    commit('changeQC', {
      loading: true,
    });

    const { data } = state;
    if (payload && payload.type) {
      data.form['result_check'] = payload.type;
    }
    let result = await ApiPostRequest(`opr/quality-control`, data.form);
    commit('changeQC', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateQC({ commit, state, dispatch }, payload = null) {
    commit('changeQC', {
      loading: true,
    });

    const { data } = state;
    if (payload && payload.type) {
      data.form['result_check'] = payload.type;
    }
    let result = await ApiPutRequest(
      `opr/quality-control/${payload.id}`,
      data.form
    );
    commit('changeQC', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteQC({ commit, dispatch }, payload = null) {
    commit('changeQC', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/quality-control/${payload.id}`);
    commit('changeQC', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
